import { TrackDetails } from 'keen-slider/react';
import { fullCircleDeg, halfCircleDeg } from '../constants';

type SlideValuesOptions = {
  slidesPerView: number;
  wheelSize: number;
  radius: number;
  sliderState: TrackDetails | null;
};
export const getSlideValues = (
  data: Array<number | string>,
  option: SlideValuesOptions,
): Array<{ style: Record<string, string>; value: string | number }> => {
  const { slidesPerView, wheelSize, radius, sliderState } = option;

  if (!sliderState) return [];

  const half = 1 / 2;
  const slideOffset = 1 / slidesPerView;
  const halfSlideOffset = half * slideOffset;
  const offset = half - halfSlideOffset;

  return data.map((value, i) => {
    const distance = sliderState ? (sliderState.slides[i]?.distance - offset) * slidesPerView : 0;

    const rotate =
      Math.abs(distance) > wheelSize / 2
        ? halfCircleDeg
        : distance * (fullCircleDeg / wheelSize) * -1;

    const style = {
      transform: `rotateX(${rotate}deg) translateZ(${radius}px)`,
      WebkitTransform: `rotateX(${rotate}deg) translateZ(${radius}px)`,
    };

    return { style, value };
  });
};
